<style scoped>
    .menu-c {
        display: flex;
        flex-direction: column;
        z-index: 20;
        background: white;
    }
    .search-c {
        padding: 10px;
    }
    .content-c {
        flex: 1;
        overflow: auto;
    }
    .content-item {
        padding: 10px 10px 0;
         cursor: pointer;
    }
        .content-item:hover {
        background: #eeeeee;
    }
    .person-c {
        padding: 0 10px;
        margin-bottom: 0px !important;
    }
    .item-detial {
        padding: 0 10px;
        display: block;
        margin: 5px;
        padding: 3px 6px;
        border: 1px solid #dddee1;
        border-radius: 4px;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .item-detial:hover {
          background: #eeeeee;
    }
</style>
<template>
  <v-menu
    ref="menu"
    v-model="menu"
    content-class="menu-c"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-x
    top
    :max-height="contentHeigh"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="item_hash[my_value] || ''"
        :label="text"
        :placeholder="placeholder"
        :required="required"
        :rules="rules"
        :disabled="disabled"
        readonly
        v-bind="attrs"
        v-on="on"
      >
        <template v-slot:label> 
          <span><span
            v-show="required"
            style="color:red"
          >*</span>{{ text }}</span>
        </template>
      </v-text-field>
    </template>
    <div class="search-c">
      <v-text-field
        v-model="in_params.search"
        :loading="getListLoading"
        append-icon="mdi-search-web"
        clearable
        @click:append="search"
      />
    </div>
    <div
      class="content-c"
    >
      <!-- v-if="outParams.type==='person'" -->
      <div>
        <div
          v-for="(item,index) in list"
          :key="index"
        >
          <p class="person-c">
            {{ item.name }}
          </p>
          <div
            v-for="(c_item) in item.payee_company_accounts"
            :key="c_item.id"
            class="item-detial"
            @click="()=>{selectDate(item,c_item,index,list,item.payee_company_accounts)}"
          >
            {{ c_item.account }}-{{ c_item.bank }}-{{ c_item.bank_number }}
          </div>
        </div> 
      </div>
      <!-- <div
        v-for="(item,index) in list"
        :key="index"
        class="content-item"
        @click="()=>selectDate(item,index,list)"
      >
        <RenderContain 
          :render="(h)=>{
            return render(h,item,index,list)
          }"
        />
      </div> -->
    </div>
  </v-menu>
</template>
<script>
  import { query_payee_company_account} from '../service'
  const RenderContain = {
    props: {
      render: {
        type: Function,
      }
    },
    render(h) {
      return this.render(h)
    }
  } 
  export default {
    components: {RenderContain},
    props: {
      disabled: {
        type: Boolean,
      },
      outList: {
        type: Array,
        default: () => []
      },
      value: {
        type: [String, Number]
      },
      text: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: '点击选择'
      },
      required: {
        type: Boolean,
      },
      rules: {
        type: Array,
      },
      outParams: {
        type: Object,
        default: () => ({})
      },
      contentHeigh: {
        type: Number,
        default:() => 300
      },
    },
    data() {
      return {
        menu: false,
        date: '',
        in_params: {
          search: '',
        },
        list: [],
        history_item_hash: {},
        getListLoading: false,
        my_value: this.value
      }
    },
    computed: {
      item_hash() {
        const arr = [...this.outList, ...this.list]
        return arr.reduce((total, item) => {
          total[item.id] = item.name
          return total
        }, {})
      }
    },
    watch: {
      menu(val) {
        val && this.search()
      },
      my_value(val) {
        this.$emit('input', val)
      },
      value(val) {
        this.my_value = val
      }
    },
    methods: {
      search(c = {}) {
        const params = {
          ...this.outParams,
          ...this.in_params,
          ...c
        }
        this.getListLoading = true
        this.$http.get(query_payee_company_account, params).then(data => {
         
          this.list = data.payee_companies
        }).finally(() => {
          this.getListLoading = false
        })
      },
      selectDate(item, c_item, index, list, payee_company_accounts) {
        this.$refs.menu.save(item);
        this.my_value = item.id
        this.$emit('change', item.id, item, c_item, index, list, payee_company_accounts);
      }
    }
  }
</script>
